import { SvgIcon } from "@mui/material";

export default function DepositIcon({ ...restProps }) {
  return (
    <SvgIcon
      {...restProps}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77835 1.3335C7.07218 1.3335 5.36647 1.98495 4.0648 3.28662C1.46147 5.88995 1.46147 10.1104 4.0648 12.7137C6.66814 15.317 10.8886 15.317 13.4919 12.7137C16.0952 10.1104 16.0952 5.88995 13.4919 3.28662C12.1902 1.98495 10.4845 1.3335 8.77835 1.3335ZM8.77835 2.66683C10.1433 2.66683 11.5078 3.188 12.5492 4.22933C14.6318 6.312 14.6318 9.68833 12.5492 11.771C10.4665 13.8537 7.09018 13.8537 5.00751 11.771C2.92485 9.68833 2.92485 6.312 5.00751 4.22933C6.04885 3.188 7.41335 2.66683 8.77835 2.66683ZM7.05439 5.3335L6.11168 6.2762L9.16897 9.3335H6.77835V10.6668H11.445V6.00016H10.1117V8.39079L7.05439 5.3335Z"
        fill="white"
      />
    </SvgIcon>
  );
}
